export default "__VITE_ASSET__CmBDm1b3__"